export default {
  API_PRO: 'http://127.0.0.1:8000',
  API_DEV: 'http://127.0.0.1:8000',
}
